import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import AssetParametersService from '../../components/services/AssetParametersService';

const useAssetParametersService = () => {
  return useMemo(() => new AssetParametersService(new ApiCalls()), []);
};

export default useAssetParametersService;
